// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5fUU-","delete":"styles_delete__Z1Sjk","update":"styles_update__3XELR","add":"styles_add__20Nov"};